import React from "react";

import { templates } from "@reactivated";

import { FilterableList } from "../components/FilterableList";
import { PageSkeleton } from "../components/PageSkeleton";
import { toolboxComponents } from "../components/PageSkeleton/Toolbox";
import { TrackedStreamField } from "../components/PageSkeleton/TrackedStreamField";

export const Template = (props: templates.ArticleCategoryPageTemplate) => (
    <PageSkeleton {...props.page} isPreview={props.is_preview}>
        <TrackedStreamField
            value={props.page.body.value}
            components={{
                ...toolboxComponents,
                filtered_list: (block) => (
                    <FilterableList
                        items={props.page.list_articles}
                        categories={props.page.filterable_categories}
                        {...block}
                    />
                ),
            }}
            tagName={React.Fragment}
        />
    </PageSkeleton>
);
